export function isTrackingHost(hostname) {
  return (
    String(hostname).toLowerCase().replace(/\.$/, "") === "tracking.wayuvega.in"
  );
}

export function trackingPathAction(pathname) {
  if (pathname === "/track") return "track";
  if (pathname === "/" || pathname === "/track/") return "redirect";
  return "notfound";
}
